export function checked(value, { message, checkedValue }) {
    if (value !== (checkedValue !== null && checkedValue !== void 0 ? checkedValue : true)) {
        return message || 'this field must be checked';
    }
}
